// extracted by mini-css-extract-plugin
module.exports = {"matchCentreLeagueTable":"matchCentreLeagueTable_matchCentreLeagueTable__ZcpKa"};